angular.module('natgeo').controller('Level4TestScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'UserProgress', 'CommonFunctions', 'SoundEngine',
function Level4TestScreen($scope, element, ScreenFactory, manager, container, UserProgress, CommonFunctions, SoundEngine)
{
	var screen = ScreenFactory( 'level4_test', element );

	// Parameters of the simulation
	var calculator = anim8.calculator[ '2d' ];
	var subCount = 5;
	var cloudCount = 8;
	var maxForce = 1000;
	var maxVelocity = 50;
	var sineWavelength = 80;
	var sineAmplitude = 20;
	var randomSeparation = 60;
	var randomOffset = 80;
	var followerVelocity = 20;
	var followerBuffer = 20;
	var followerThickness = 2;
	var targetChanged = false;
	var timeLimit = 45;
	var epsilon = 1;
	var viewportBounds = {x: 10, y: 215, w: 525, h: 3063, viewHeight: 670};
	var targetRandomOffset = 10;
	var collisionDistance = 40;
	var maxRotationPerSecond = 360;
	var cloudStartAmount = 1000;
	var cloudRemovePerSecond = 80;
	var oceanStart = -2968;
	var oceanOffset = oceanStart;
	var shipMoveTime = 8;

	var currentGarbage = 0;
	var currentPower = 0;
	var currentDamage = 0;

	var simulating = false;
	var target = false;
	var subs = [];
	var clouds = [];
	var cloudFadeOut = {
		keyframe: {
			from: {
				opacity: true
			},
			to: {
				opacity: 0
			}
		}
	};

	// The points the target can be moved to based on key input
	var targetSpots = [ // 690 x 545
		// Row 1
		{ x: 172.50 * 0 + 86.25, y: 136.25 * 0 + 68.12 },
		{ x: 172.50 * 1 + 86.25, y: 136.25 * 0 + 68.12 },
		{ x: 172.50 * 2 + 86.25, y: 136.25 * 0 + 68.12 },
		{ x: 172.50 * 3 + 86.25, y: 136.25 * 0 + 68.12 },
		// Row 2
		{ x: 172.50 * 0 + 86.25, y: 136.25 * 1 + 68.12 },
		{ x: 172.50 * 1 + 86.25, y: 136.25 * 1 + 68.12 },
		{ x: 172.50 * 2 + 86.25, y: 136.25 * 1 + 68.12 },
		{ x: 172.50 * 3 + 86.25, y: 136.25 * 1 + 68.12 },
		// Row 3
		{ x: 172.50 * 0 + 86.25, y: 136.25 * 2 + 68.12 },
		{ x: 172.50 * 1 + 86.25, y: 136.25 * 2 + 68.12 },
		{ x: 172.50 * 2 + 86.25, y: 136.25 * 2 + 68.12 },
		{ x: 172.50 * 3 + 86.25, y: 136.25 * 2 + 68.12 },
		// Row 4
		{ x: 172.50 * 0 + 86.25, y: 136.25 * 3 + 68.12 },
		{ x: 172.50 * 1 + 86.25, y: 136.25 * 3 + 68.12 },
		{ x: 172.50 * 2 + 86.25, y: 136.25 * 3 + 68.12 },
		{ x: 172.50 * 3 + 86.25, y: 136.25 * 3 + 68.12 }
	];

	// The array of path generation functions based on a controller value (0-2).
	// A path generation function takes a start point and end point and returns
	// a function that generates points between them based on some criteria.
	var controllers = 
	[
		Paths.Sine( sineWavelength, sineAmplitude ),
		Paths.Linear,
		Paths.Random( randomSeparation, randomOffset )
	];

	// How effective each controller is at cleaning up trash
	var controllerEffectiveness = [
		0.34, /* Serpentine */
		0.34, /* Straight */
		0.00  /* Random */
	];
	var controllerPower = [
		0.00, /* Serpentine */
		0.00, /* Straight */
		0.00  /* Random */
	];
	var controllerDamage = [
		0.10, /* Serpentine */
		0.00, /* Straight */
		0.15  /* Random */
	];

	// How effective each end effector is at cleaning up trash
	var effectorEffectiveness = [
		0.10, /* Magnet */
		0.33, /* Arm */
		0.66  /* Net */
	];
	var effectorPower = [
		0.00, /* Magnet */
		0.00, /* Arm */
		0.00  /* Net */
	];
	var effectorDamage = [
		0.00, /* Magnet */
		0.00, /* Arm */
		0.00  /* Net */
	];

	// How effective each motor is at cleaning up trash
	var motorEffectiveness = [
		0.00, /* Propeller */
		0.00  /* Hybrid */
	];
	var motorPower = [
		0.20, /* Propeller */
		0.50  /* Hybrid */
	];
	var motorDamage = [
		0.15, /* Propeller */
		0.00  /* Hybrid */
	];

	// How effective each body is at cleaning up trash
	var bodyEffectiveness = [
		0.00, /* Cylinder */
		0.00  /* Rectangle */
	];
	var bodyPower = [
		0.50, /* Cylinder */
		0.00  /* Rectangle */
	];
	var bodyDamage = [
		0.00, /* Cylinder */
		0.00  /* Rectangle */
	];

	// Visibility based on Sensor
	var sensorVisibility = [
		0.00, /* Sonar */
		1.00  /* Camera */
	];

	// Add submarine selection functions to $scope
	CommonFunctions.setupSubmarineFunctions($scope, UserProgress);

	// Cloud templates
	screen.clouds = screen.view.find('.clouds');

	// How many simulations in this session
	screen.simulations = 0;

	// Meter dots!
	screen.dotsGarbage = screen.view.find('.dot-garbage');
	screen.dotsPower = screen.view.find('.dot-power');
	screen.dotsDamage = screen.view.find('.dot-damage');

	// Change Murkiness Based on User's Selection
	screen.on('introBefore', function()
	{
		screen._murky.setAttributes(
		{
			opacity: sensorVisibility[ UserProgress.SubmarineSensor ]
		});

		screen._startSimulation.addClass('hidden');
		screen._success.addClass('hidden');
		screen._fail.addClass('hidden');

		screen._intro.removeClass('hidden');
		screen._sidebar.css('zIndex', '');

		target = false
		targetChanged = false;
	});

	// Make Start Button Appear after Intro
	screen.on('introEnd', function()
	{
		screen.introduce( 'startSimulation', 'zoomIn' );
	});

	// Updates the opacity of the dots given a value
	screen.updateDots = function(dots, value)
	{
		var opacity = dots.length * value;

		for (var i = 0; i < dots.length; i++)
		{
			anim8( dots[i] ).set(
			{
				scale: anim8.clamp( opacity - i, 0, 1 )
			});
		}
	};

	// Shows the success dialog
	screen.showSuccess = function()
	{
		CommonFunctions.showHelp( screen._success, function()
		{
			screen._sidebar
				.play('fadeIn')
				.applyInitialState()
				.css('zIndex', 50)
			;
		});
		screen._success.css('zIndex', '');
	};

	// Shows the failure dialog
	screen.showFailure = function()
	{
		CommonFunctions.showHelp( screen._fail, function()
		{
			screen._sidebar
				.play('fadeIn')
				.applyInitialState()
				.css('zIndex', 50)
			;
		});
		screen._fail.css('zIndex', '');
	};

	// "Draw" the submarine
	screen.drawSubmarine = function(sub, dt)
	{
		var x = (sub.position.x - 33 * 0.5);
		var y = (sub.position.y - 57 * 0.5);

		var attributes = 
		{
			left: x * container.getScale(),
			top:  y * container.getScale()
		};

		sub.rectangle.x = x;
		sub.rectangle.y = y - oceanOffset;

		if ( !calculator.isZero( sub.direction, 0.001 ) )
		{
			var heading = Math.atan2( sub.direction.y, sub.direction.x ) * 180 / Math.PI + 90;

			if ( !anim8.isNumber( sub.angle ) )
			{
				sub.angle = anim8.wrapAngle( heading );
			}
			else
			{
				var a0 = anim8.wrapAngle( sub.angle );
				var a1 = anim8.wrapAngle( heading );

				if ( Math.abs( a0 - a1 ) > 180 )
				{
					if ( a0 > a1 )
					{
						a1 += 360;
					}
					else
					{
						a0 += 360;
					}
				}
				var changeMax = maxRotationPerSecond * dt;
				var change = anim8.clamp( a1 - a0, -changeMax, +changeMax );

				sub.angle += change;
			}

			attributes.rotate = sub.angle;
		}

		sub.animator.set( attributes );
	};

	// Keep the submarine on the screen
	screen.containSubmarine = function(sub)
	{
		var hw = sub.rectangle.w * 0.5;
		var hh = sub.rectangle.h * 0.5;
		var padding = 30;
		var cw = 690;
		var ch = 545;

		sub.position.x = anim8.clamp( sub.position.x, padding + hw, cw - padding - hw );
		sub.position.y = anim8.clamp( sub.position.y, padding + hh, ch - padding - hh );
	};

	// Kill existing submarines
	screen.destroySimulation = function()
	{
		for (var i = 0; i < subs.length; i++)
		{
			subs[ i ].animator.play('fadeOut').once('finished', function() {this.remove()}, subs[ i ].sprite );
		}

		subs.length = 0;

		for (var k = 0; k < clouds.length; k++)
		{
			clouds[ k ].animator.play( cloudFadeOut ).once('finished', function() {this.remove()}, clouds[ k ].sprite );
		}

		clouds.length = 0;
	};

	// Prepares for the simulation
	screen.setupSimulation = function()
	{
		targetChanged = false;

		// Stop existing simulation!
		screen.destroySimulation();

		// Place some submarines
		for (var i = 0; i < subCount; i++)
		{
			var sub = new Subject( calculator );
			sub.sprite = screen._submarine.clone();
			sub.sprite.removeAttr('anim8');
			sub.sprite.insertBefore( screen._oceanTop );
			sub.animator = sub.sprite.animators()[0];
			sub.animator.play( 'fadeIn' );
			sub.animator.applyInitialState();
			sub.follower = false;
			sub.path = false;
			sub.moving = false;
			sub.position.x = 80 + 60 * i;
			sub.position.y = viewportBounds.viewHeight - 60 - (i % 2) * 50 - 220;
			sub.velocity.x = 0;
			sub.velocity.y = -0.000001;
			sub.direction.x = 0;
			sub.direction.y = -1;
			sub.maxVelocity = maxVelocity;
			sub.rectangle = {x: 0, y: 0, w: 33, h: 57};

			screen.drawSubmarine( sub, 0 );

			subs[ i ] = sub;
		}

		// Place clouds in the viewport!
		for (var k = 0; k < cloudCount; k++)
		{
			var cloud = {};

			cloud.sprite = screen.clouds.random().clone();
			cloud.sprite.removeAttr('anim8');
			cloud.sprite.appendTo( screen._ocean );
			cloud.animator = cloud.sprite.animators()[0];
			cloud.animator.play( 'fadeIn' );
			cloud.animator.applyInitialState();
			cloud.sprite.scale( container.getScale() );
			cloud.w = parseFloat( cloud.sprite.data('width') );
			cloud.h = parseFloat( cloud.sprite.data('height') );
			cloud.amount = cloudStartAmount;

			var tries = 0;
			do
			{
				cloud.x = (viewportBounds.w - cloud.w) * Math.random() + viewportBounds.x;
				cloud.y = (viewportBounds.h - cloud.h) * Math.random() + viewportBounds.y;
				tries++;
			}
			// Keep trying to place the cloud so it doesn't intersect with the starting positions and any of the other clouds
			while ( screen.getCloud( cloud ) !== false && tries < 1000 );

			// Cloud placed!
			cloud.sprite.data( 'left', cloud.x );
			cloud.sprite.data( 'top', cloud.y );
			cloud.sprite.scale( container.getScale() );

			clouds.push( cloud );
		}
	};

	// Handles a collision between two subjects of equal mass.
	screen.handleCollision = function(a, b)
	{
		var calc = calculator;
		var rsq = collisionDistance * collisionDistance;
		var collision = calc.sub( calc.clone( a.position ), b.position );
		var dsq = calc.lengthSq( collision );

		// Collision?
		if ( dsq < rsq && dsq !== 0 )
		{
			var distance = Math.sqrt( dsq );
			var intersect = (collisionDistance - distance) / collisionDistance * 0.5;

			a.position = calc.adds( a.position, collision, +intersect );
			b.position = calc.adds( b.position, collision, -intersect );

			collision = calc.scale( collision, 1.0 / distance );

			var adot = calc.dot( a.velocity, collision );
			var bdot = calc.dot( b.velocity, collision );

			a.velocity = calc.adds( a.velocity, collision, bdot - adot );
			b.velocity = calc.adds( b.velocity, collision, adot - bdot );

			return true;
		}

		return false;
	};

	// Whether the two rectangles are intersecting
	screen.intersecting = function(a, b)
	{
		var aL = a.x;
		var aR = a.x + a.w;
		var aT = a.y;
		var aB = a.y + a.h;
		var bL = b.x;
		var bR = b.x + b.w;
		var bT = b.y;
		var bB = b.y + b.h;

		return !(
			aL > bR ||
			aR < bL ||
			aT > bB ||
			aB < bT
		);
	};

	// Returns which cloud the given rectangle intersects with (optionally clouds with trash in them)
	screen.getCloud = function(a, notEmpty)
	{
		for (var k = 0; k < clouds.length; k++)
		{
			var c = clouds[ k ];

			if ( screen.intersecting( a, c ) && (!notEmpty || c.amount > 0) )
			{
				return c;
			}
		}

		return false;
	};

	// Function triggered when a simulation has finished.
	screen.onSimulateEnd = function( success )
	{
		if ( screen.CANCEL )
		{
			return;
		}

		if ( !$scope.$$phase )
		{
			$scope.$apply();
		}

		if ( success )
		{
			SoundEngine.play( 'goal-achieved' );

			screen.showSuccess();
		}
		else
		{
			// NO TIME REMAINING SON!
			screen._timeRemaining.play('pulse');

			// Show the intro dialog.
			screen.outroduce( 'tap', 'bounceOut 0.5s' );
			
			// Wait a second until we set it up again
			setTimeout( screen.showFailure, 1000 );
		}

		// Destroy the current one
		screen.destroySimulation();
	};

	// Start the simulation!
	$scope.simulate = function()
	{
		// Hide the intro dialog.
		screen.outroduce( 'intro', 'fadeOut 0.2s' );

		var calc = calculator;
		var start = anim8.now();
		var lastElapsed = 0;

		// The paths are generated based on the selected controller.
		var pathGenerator = controllers[ UserProgress.SubmarineController || 0 ];

		// Effectiveness, power efficiency, and damage are the sum of the user's selection.
		var effectiveness = 
			controllerEffectiveness[ UserProgress.SubmarineController ] +
			effectorEffectiveness[ UserProgress.SubmarineEffector ] +
			motorEffectiveness[ UserProgress.SubmarineMotor ] +
			bodyEffectiveness[ UserProgress.SubmarineBody ];

		var power =
			controllerPower[ UserProgress.SubmarineController ] + 
			effectorPower[ UserProgress.SubmarineEffector ] + 
			motorPower[ UserProgress.SubmarineMotor ] + 
			bodyPower[ UserProgress.SubmarineBody ];

		var damage = 
			controllerDamage[ UserProgress.SubmarineController ] + 
			effectorDamage[ UserProgress.SubmarineEffector ] + 
			motorDamage[ UserProgress.SubmarineMotor ] + 
			bodyDamage[ UserProgress.SubmarineBody ];

		// A temporary variable used to calculate the force for a given submarine.
		var force = calc.create();
		var collisionCount = 0;

		// The maximum amount that can be removed from a cloud
		var cloudMaxAmount = Math.max( 0, (1 - effectiveness) * cloudStartAmount - 1 );

		simulating = true;

		screen.simulations++;

		// Reset Scrolling Ocean
		oceanOffset = oceanStart;
		screen._ocean
			.data('top', oceanStart)
			.scale( container.getScale() )
		;
		screen._oceanTop
			.data('top', oceanStart)
			.scale( container.getScale() )
		;

		// Reset Ships
		screen._shipDeploy.setAttributes(
		{
			translateX: '0%'
		});
		screen._shipPickup.setAttributes(
		{
			translateX: '-200%'
		});

		SoundEngine.play( 'ocean', {loop:-1} );

		var run = function()
		{
			var elapsed = (anim8.now() - start) * 0.001;
			var dt = elapsed - lastElapsed;
			var doneSimulating = elapsed > timeLimit;
			var elapsedDelta = anim8.clamp( elapsed / timeLimit, 0, 1 );
			var doneMoving = true;
			var followingCount = 0;
			var tapper = screen._tap;

			// If the user has added a target, reset the submarines paths.
			if ( targetChanged )
			{
				var total = calc.create();

				for (var i = 0; i < subs.length; i++)
				{
					total = calc.add( total, subs[ i ].position );
				}

				var center = calc.scale( total, 1.0 / subs.length );

				for (var i = 0; i < subs.length; i++)
				{
					var s = subs[ i ];
					var starget = {};
					starget.x = (s.position.x - center.x) + target.x + Math.random() * targetRandomOffset * 2 - targetRandomOffset;
					starget.y = (s.position.y - center.y) + target.y + Math.random() * targetRandomOffset * 2 - targetRandomOffset;

					s.path = pathGenerator( s.position, starget );
					s.follower = new PathFollower( s.path, calculator );
					s.follower.velocity = followerVelocity;
					s.follower.buffer = followerBuffer;
					s.follower.thickness = followerThickness;
					s.moving = true;
				}

				targetChanged = false;

				tapper
					.removeClass( 'hidden' )
					.play( 'zoomIn 0.3s' )
					.applyInitialState()
					.queueAnimation( 'pulse infinite' )
					.data( 'left', target.x - 29 )
					.data( 'top', target.y - 29 )
					.scale( container.getScale() )
				;
			}

			// Update Ocean Translation
			if ( elapsed > 1 && elapsed < timeLimit - 1 )
			{
				var oceanDelta = 1 - anim8.clamp( (elapsed - 1) / (timeLimit - 2), 0, 1 );

				oceanOffset = oceanDelta * oceanStart;

				screen._ocean
					.data( 'top', oceanOffset )
					.scale( container.getScale() )
				;
				screen._oceanTop
					.data( 'top', oceanOffset )
					.scale( container.getScale() )
				;
			}

			// Update Deploy Ship
			if ( elapsed < shipMoveTime )
			{
				screen._shipDeploy.setAttributes(
				{
					translateX: ((elapsed / shipMoveTime) * 200) + '%'
				});
			}

			// Update Pick-up Ship
			if ( elapsed > timeLimit - shipMoveTime && !doneSimulating )
			{
				screen._shipPickup.setAttributes(
				{
					translateX: (((elapsed - timeLimit) / shipMoveTime) * 200) + '%'
				});
			}

			// For each submarine in my command...
			for (var i = 0; i < subs.length; i++)
			{
				var s = subs[ i ];

				force = calc.zero( force );

				// If the submarine is moving....
				if ( s.moving )
				{
					// Follow the path commanded by the almighty user!
					if ( s.follower && !doneSimulating )
					{
						force = s.follower.getForce( force, s );
						force = calc.setLength( force, maxForce );
						followingCount++;
					}
					else
					{
						// Brakes!
						force = calc.copy( force, s.velocity );
						force = calc.scale( force, -1 );
					}
				}
				// If this submarine is following a path but has finished, remove the follower.
				if ( s.follower && s.follower.destination )
				{
					s.follower = false;
				}
				// If the submarine is moving but the force being applied and the current velocity
				// is close to zero, consider the submarine not to be moving anymore. A still submarine
				// cannot clean up trash.
				if ( s.moving && calc.isZero( force, epsilon ) && calc.isZero( s.velocity, epsilon ) )
				{
					s.moving = false;
				}

				// Updates the submarines velocity, position, & direction
				s.update( force, dt );

				// Keep the submarine on the screen
				screen.containSubmarine( s );

				// Draw the submarine and orient it to match it's direction (while not 
			  // allowing the submarine to rotate to quickly).
				screen.drawSubmarine( s, dt );

				// If the submarine is moving and the simulation is not done running,
				// if this submarine is under a cloud of trash remove some of the trash
				// based on the how much can be removed per second multiplied by the
				// effectiveness of the user's submarine part selection
				if ( s.moving && !doneSimulating )
				{
					var cloud = screen.getCloud( s.rectangle, true );

					if ( cloud !== false )
					{
						cloud.amount -= cloudRemovePerSecond * dt * effectiveness;
						cloud.amount = Math.max( cloudMaxAmount, cloud.amount );

						if ( cloud.amount === 0 )
						{
							SoundEngine.play( 'goal-achieved', {volume:0.05} );
						}
					}
				}

				doneMoving = doneMoving && !s.moving;
			}

			// If no submarines are following a path and the tapper is still visible
			if ( followingCount === 0 && !tapper.hasClass('hidden') && !tapper.isAnimating() )
			{
				screen.outroduce( 'tap', 'bounceOut 0.5s' );
			}

			// The submarines bounce off of each other!
			for (var i = 0; i < subs.length + 1; i++)
			{
				for (var k = i + 1; k < subs.length; k++)
				{
					if ( screen.handleCollision( subs[ i ], subs[ k ] ) )
					{
						collisionCount++;
					}
				}
			}

			// Calculate the total amount of trash picked up.
			var maxAmount = cloudCount * cloudStartAmount;
			var totalAmount = 0;

			for (var k = 0; k < clouds.length; k++)
			{
				var c = clouds[ k ];
 
				c.animator.set(
				{
					opacity: c.amount / cloudStartAmount
				});

				totalAmount += c.amount;
			}

			// Update Time Remaining
			screen._timeRemaining.html( Math.max( 0, timeLimit - elapsed ).toFixed( 0 ) );

			// Last elapsed is now this elapsed
			lastElapsed = elapsed;

			// Update Meters
			screen.updateDots( screen.dotsGarbage, currentGarbage = ((maxAmount - totalAmount) / maxAmount) );
			screen.updateDots( screen.dotsPower, currentPower = (elapsedDelta * power) );
			screen.updateDots( screen.dotsDamage, currentDamage = (elapsedDelta * damage) );

			// Stop when the user has ran out of time and the submarines are still OR if the user left the screen.
			if ( (doneSimulating && doneMoving) || screen.CANCEL )
			{
				simulating = false;

				SoundEngine.stopAll();

				screen.onSimulateEnd( currentGarbage >= 0.75 && currentPower >= 0.3 );
			}
			else
			{
				anim8.requestRun( run );
			}
		};

		anim8.requestRun( run );
	};

	// Command the subs where to go!
	$scope.commandSubs = function(e)
	{
		if ( simulating )
		{
			var origin = screen._viewport.offset();

			targetChanged = true;

			target = 
			{
				x: (e.pageX - origin.left) / container.getScale(),
				y: (e.pageY - origin.top) / container.getScale()
			};	
		}
	};

	// Stop existing simulation!
	screen.on('outroBegin', function()
	{
		screen.CANCEL = true;
		screen.destroySimulation();
	});

	// Setup simulation after screen intro
	screen.on('introEnd', function()
	{
		screen.simulations = 0;
		screen.setupSimulation();
	});

	// Shrink/grow dots on screen entry
	screen.on('introBefore', function()
	{
		screen.CANCEL = false;
		screen._intro.removeClass( 'hidden' );

		screen.updateDots( screen.dotsGarbage, 0 );
		screen.updateDots( screen.dotsPower, 0 );
		screen.updateDots( screen.dotsDamage, 0 );
	});

	// Key Input
  screen.on('introBefore', function()
  {
    Shortcuts.down( { key: Shortcuts.keys.Left }, screen.moveTarget( -131.25, 0 ) );
    Shortcuts.down( { key: Shortcuts.keys.Right }, screen.moveTarget( 131.25, 0 ) );
    Shortcuts.down( { key: Shortcuts.keys.Up }, screen.moveTarget( 0, -167.50 ) );
    Shortcuts.down( { key: Shortcuts.keys.Down }, screen.moveTarget( 0, 167.50 ) );
  });
  screen.on('outroBegin', function()
  {
    Shortcuts.off();
  });
  screen.moveTarget = function(dx, dy)
  {
  	return function()
  	{
  		if ( target && simulating )
  		{
  			var rdx = dx + target.x;
  			var rdy = dy + target.y;
  			var closest = false;
  			var closestDistanceSq = false;

  			angular.forEach( targetSpots, function(spot)
  			{
  				var sdx = spot.x - rdx;
  				var sdy = spot.y - rdy;
  				var sdsq = sdx * sdx + sdy * sdy;

  				if ( closest === false || sdsq < closestDistanceSq )
  				{
  					closest = spot;
  					closestDistanceSq = sdsq;
  				}
  			});

  			target = closest;
  			targetChanged = true;
  		}
  	};
  };

  // Returns the amount text.
  $scope.getAmount = function()
  {
  	return currentGarbage >= 0.75 ? 'High' : (currentGarbage >= 0.3 ? 'Medium' : 'Low');
  };

  // Returns the amount text.
  $scope.getEfficiency = function()
  {
  	return currentPower >= 0.75 ? 'High' : (currentPower >= 0.3 ? 'Medium' : 'Low');
  };
	
	// The next screen is the reward screen
	$scope.next = function()
	{
		manager.transition('level4_reward');
	};

	// Restart the submarine build.
	$scope.restart = function()
	{
		manager.transition('level4_build_body');
	};

	// We failed, replay the level.
	$scope.replay = function()
	{
		screen.setupSimulation();

		screen._sidebar
			.play('fadeOut 0.5s')
			.applyInitialState()
			.animators()
			.once('finished', function()
			{
				screen._sidebar
					.css({
						zIndex: '',
						opacity: 1
					})
			})
		;

		CommonFunctions.hideHelp( screen._fail, $scope.simulate );
	};
	
	// The previous screen is the build controller screen
	$scope.prev = function()
	{
		manager.transition('level4_build_controller');
	};
	
}]);